async function fetchPauseSubscription({ uid, productId, productType, monthsToPause }) {
  const API = `https://us-central1-auto-clupp.cloudfunctions.net/cluppAPIV1/v1/users/${uid}/pause-subscription`;

  const url = new URL(API);
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmdhbml6YXRpb24iOiJSQVNUUkVBVE9SIn0.OGp_G6Lref09-YkoRsY3vBUEndMpAbhUR-tHHu-nlm4",
      },
      body: JSON.stringify({
        productId,
        productType,
        monthsToPause
      }),
    });
    if (!response.ok) {
      console.log("[Error subscription pause]", response.status, response.statusText);
      throw new Error("Failed to fetch subscription pause");
    }

    const json = await response.json();
  
    
    return json;
  } catch (error) {
    console.log("[Error subscription pause]", error);
    throw new Error("Error subscription pause");
  }
}

export default fetchPauseSubscription;
